// import React, { useRef, useState } from "react";
// import {
//   Modal,
//   Box,
//   Typography,
//   Grid,
//   Divider,
//   Button,
//   Table,
//   TableHead,
//   TableBody,
//   TableRow,
//   TableCell,
// } from "@mui/material";
// import toast from "react-hot-toast";
// import saleService from "../Services/saleService";
// import { useNavigate } from "react-router-dom";

// const MedicineInvoiceModal = ({
//   open,
//   onClose,
//   patientName,
//   doctorName,
//   servicesName,
//   patientId,
//   doctorId,
//   saleDate,
//   salesRows,
// }) => {
//   const receiptRef = useRef(null);
//   const navigate = useNavigate();
//   const [invoiceId, setInvoiceId] = useState(null);

//   // Calculate the total amount
//   const calculateTotal = () =>
//     salesRows.reduce(
//       (acc, row) => acc + (row.quantity * row.unit_price || 0),
//       0
//     );

//   // Format total as currency
//   const formatCurrency = (amount) => {
//     const validAmount = Number(amount) || 0;
//     return `${validAmount.toFixed(2)}`;
//   };

//   // const handleSubmitSales = async () => {
//   //   try {
//   //     if (!salesRows.length) {
//   //       toast.error("No sales data to submit.");
//   //       return;
//   //     }

//   //     const invoiceData = await saleService.createInvoices(invoiceId);
//   //     setInvoiceId(invoiceData.invoiceId); // Update invoice ID
//   //     toast.success(`Invoice created successfully. ID: ${invoiceData.invoiceId}`);

//   //     const salesData = salesRows.map((row) => ({
//   //       stock_id: row.stock_id,
//   //       quantity: parseInt(row.quantity, 10),
//   //       unit_price: parseFloat(row.unit_price),
//   //       patient_id: patientId,
//   //       doctor_id: doctorId,
//   //       sale_date: saleDate,
//   //       invoice: invoiceId,
//   //     }));

//   //     await Promise.all(salesData.map((row) => saleService.create(row)));
//   //     toast.success("Sales submitted successfully!");
//   //     onClose();
//   //     navigate("/dispenser");
//   //   } catch (error) {
//   //     toast.error("Error submitting sales.");
//   //   }
//   // };

//   const handleSubmitSales = async () => {
//     try {
//       if (!salesRows.length) {
//         toast.error("No sales data to submit.");
//         return;
//       }
  
//       // Step 1: Create the invoice
//       let createdInvoiceId;
//       try {
//         const invoiceData = await saleService.createInvoices();
//         createdInvoiceId = invoiceData.invoiceId; // Get the created invoice ID
//         toast.success(`Invoice created successfully. ID: ${createdInvoiceId}`);
//       } catch (error) {
//         toast.error("Error creating invoice. Sales submission aborted.");
//         return; // Exit if invoice creation fails
//       }
  
//       // Step 2: Prepare sales data with the created invoice ID
//       const salesData = salesRows.map((row) => ({
//         stock_id: row.stock_id,
//         quantity: parseInt(row.quantity, 10),
//         unit_price: parseFloat(row.unit_price),
//         patient_id: patientId,
//         doctor_id: doctorId,
//         sale_date: saleDate,
//         invoice: createdInvoiceId, // Use the newly created invoice ID
//       }));
  
//       // Step 3: Submit the sales data
//       try {
//         await Promise.all(salesData.map((row) => saleService.create(row)));
//         toast.success("Sales submitted successfully!");
//         onClose(); // Close the modal
//         navigate("/dispenser"); // Navigate to the dispenser page
//       } catch (error) {
//         toast.error("Not in Stock");
//       }
//     } catch (error) {
//       toast.error("Unexpected error occurred.");
//     }
//   };
  


//   const formatDate = (date) => {
//     const d = new Date(date);
//     const day = String(d.getDate()).padStart(2, "0"); // Get day and pad with leading zero if needed
//     const month = String(d.getMonth() + 1).padStart(2, "0"); // Get month and pad with leading zero if needed
//     const year = d.getFullYear(); // Get full year

//     return `${day}-${month}-${year}`; // Return formatted date as DD-MM-YYYY
//   };

//   const handlePrint = () => {
//     //const receiptContent = receiptRef.current.innerHTML;
//     const receiptContent = receiptRef.current
//       ? receiptRef.current.innerHTML.replace(/undefined|null|blank/g, "")
//       : "";
//     const printWindow = window.open("", "_blank", "width=600, height=600");
//     printWindow.document.write(`
//       <html>
//       <head>
//         <style>
//           body { font-family: calibri, sans-serif; font-size: 12px; margin: 0 auto; padding: 0;}
//           .receipt-container { width: 300px; margin: 0 auto; padding: 5px;}
//           table { width: 100%; border-collapse: collapse; }
//           th, td { text-align: left; padding: 4px; }
//           th { border-bottom: 1px solid #000; }
//         </style>
//       </head>
//       <body onload="window.print(); window.close();">
//         ${receiptContent}
//       </body>
//       </html>
//     `);
//     printWindow.document.close();
//   };

//   const handleClose = () => {
//     onClose();
//   };

//   return (
//     <Modal open={open} onClose={onClose}>
//       <Box
//         sx={{
//           width: 600,
//           p: 4,
//           backgroundColor: "white",
//           mx: "auto",
//           mt: 10,
//           maxHeight: "80vh",
//           overflow: "auto",
//         }}
//       >
//         <Typography variant="h6" gutterBottom>
//           Invoice
//         </Typography>
//         <Divider sx={{ mb: 2 }} />

//         <Grid container spacing={2}>
//           {/* Patient and Doctor Information */}
//           <Grid item xs={12}>
//             <Typography>
//               <strong>Patient:</strong> {patientName}
//             </Typography>
//             <Typography>
//               <strong>Doctor:</strong> {doctorName}
//             </Typography>
//             <Typography>
//               <strong>Sale Date:</strong> {saleDate}
//             </Typography>
//           </Grid>

//           {/* Invoice Details Table */}
//           <Grid item xs={12}>
//             <Typography variant="h6">Details:</Typography>
//             <Table sx={{ mt: 2, minWidth: 400 }}>
//               <TableHead>
//                 <TableRow>
//                   <TableCell>
//                     <strong>Name</strong>
//                   </TableCell>
//                   <TableCell>
//                     <strong>Qty</strong>
//                   </TableCell>
//                   <TableCell align="right">
//                     <strong>Unit Price</strong>
//                   </TableCell>
//                   <TableCell align="right">
//                     <strong>Total</strong>
//                   </TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {salesRows.map((row, index) => (
//                   <TableRow key={index}>
//                     <TableCell>{servicesName[index]}</TableCell>
//                     <TableCell>{row.quantity}</TableCell>
//                     <TableCell align="right">
//                       {formatCurrency(row.unit_price)}
//                     </TableCell>
//                     <TableCell align="right">
//                       {formatCurrency(row.quantity * row.unit_price)}
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </Grid>

//           {/* Total Amount */}
//           <Grid item xs={12}>
//             <Typography variant="h6" sx={{ mt: 2 }}>
//               <strong>Total:</strong> {formatCurrency(calculateTotal())}
//             </Typography>
//           </Grid>

//           {/* Buttons */}
//           <Grid item xs={12} sx={{ mt: 3, textAlign: "center" }}>
//             <Button
//               variant="contained"
//               color="primary"
//               onClick={handleSubmitSales}
//             >
//               Confirm Sales
//             </Button>
//             <Button
//               variant="outlined"
//               color="secondary"
//               onClick={handleClose}
//               sx={{ ml: 2 }}
//             >
//               Close
//             </Button>
//             <Button
//               variant="contained"
//               color="success"
//               onClick={handlePrint}
//               sx={{ ml: 2 }}
//             >
//               Print POS Receipt
//             </Button>
//           </Grid>
//         </Grid>

//         {/* Hidden POS Receipt for Printing */}
//         <div ref={receiptRef} className="hidden">
//           <div className="receipt-container w-[3in] font-calibri text-[10px]">
//             <div className="flex justify-center w-full">
//               <h1 className="text-lg font-bold text-center">
//                 Said Ahmed Memorial Medical Centre
//               </h1>
//             </div>
//             <h3 className="text-lg">Invoice # {invoiceId || "N/A"}</h3>
//             <p className="text-sm">
//               <strong>Patient:</strong> {patientName || "N/A"}
//             </p>
//             <p className="text-sm">
//               <strong>Date: </strong>
//               {formatDate(saleDate) || "N/A"}
//             </p>
//             <hr className="my-2 border-gray-300" />
//             <table className="w-full text-lg border-collapse table-fixed">
//               <thead>
//                 <tr>
//                   <th className="text-left text-lg">Name</th>
//                   <th className="text-left text-lg">Qty</th>
//                   <th className="text-right text-lg">Unit Price</th>
//                   <th className="text-right text-lg">Total</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {salesRows.map((row, index) => (
//                   <tr key={index}>
//                     <td className=" text-lg">{servicesName[index] || "N/A"}</td>
//                     <td className=" text-lg">{row.quantity || "0"}</td>
//                     <td className=" text-right text-lg">
//                       {formatCurrency(row.unit_price || 0)}
//                     </td>
//                     <td className=" text-right text-lg">
//                       {formatCurrency(
//                         (row.quantity || 0) * (row.unit_price || 0)
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//             <hr className="my-2 border-gray-300" />
//             <div className="w-full text-right">
//               <h2 className="text-2xl font-bold">
//                 Total: {formatCurrency(calculateTotal())}
//               </h2>
//               <p className="text-sm">Thank your for Your Purchase!</p>
//             </div>
//           </div>
//         </div>
//       </Box>
//     </Modal>
//   );
// };

// export default MedicineInvoiceModal;

import React, { useRef, useState } from "react";
import toast from "react-hot-toast";
import saleService from "../Services/saleService";
import { useNavigate } from "react-router-dom";

const MedicineInvoiceModal = ({
  open,
  onClose,
  patientName,
  doctorName,
  servicesName,
  patientId,
  doctorId,
  saleDate,
  salesRows,
}) => {
  const receiptRef = useRef(null);
  const invoiceIdRef = useRef(null);
  const navigate = useNavigate();
  const [invoiceId, setInvoiceId] = useState(null);
  const [confirming, setConfirming] = useState(false);
  const [saleConfirmed, setSaleConfirmed] = useState(false);

  if (!open) return null;

  // ── Helpers ──────────────────────────────────────────────
  const calculateTotal = () =>
    salesRows.reduce(
      (acc, row) => acc + (Number(row.quantity) * Number(row.unit_price) || 0),
      0
    );

  const formatCurrency = (amount) =>
    `Rs. ${(Number(amount) || 0).toFixed(2)}`;

  const formatDate = (date) => {
    if (!date) return "N/A";
    const d = new Date(date);
    return `${String(d.getDate()).padStart(2, "0")}-${String(
      d.getMonth() + 1
    ).padStart(2, "0")}-${d.getFullYear()}`;
  };

  // ── Safe close — blocked after sale is confirmed ─────────
  const handleClose = () => {
    if (saleConfirmed) return;
    onClose();
  };

  // ── Submit ───────────────────────────────────────────────
  const handleSubmitSales = async () => {
    if (confirming || saleConfirmed) return;

    if (!salesRows.length) {
      toast.error("No sales data to submit.");
      return;
    }

    setConfirming(true);

    try {
      // Step 1: Create invoice
      let createdInvoiceId;
      try {
        const invoiceData = await saleService.createInvoices();
        createdInvoiceId = invoiceData.invoiceId;
      } catch {
        toast.error("Error creating invoice.");
        return;
      }

      // Step 2: Create sales
      const salesData = salesRows.map((row) => ({
        stock_id: row.stock_id,
        quantity: parseInt(row.quantity, 10),
        unit_price: parseFloat(row.unit_price),
        patient_id: patientId,
        doctor_id: doctorId,
        sale_date: saleDate,
        invoice: createdInvoiceId,
      }));

      try {
        await Promise.all(salesData.map((row) => saleService.create(row)));
      } catch {
        toast.error("Not in Stock");
        // Rollback the unused invoice
        try {
          await saleService.deleteInvoice(createdInvoiceId);
        } catch {
          console.warn("Could not rollback invoice:", createdInvoiceId);
        }
        return;
      }

      // ✅ Both steps succeeded — update state, then close & navigate
      setInvoiceId(createdInvoiceId);
      invoiceIdRef.current = createdInvoiceId;
      toast.success(`Invoice #${createdInvoiceId} created!`);
      toast.success("Sales submitted successfully!");
      setSaleConfirmed(true);
      onClose();
      navigate("/dispenser");

    } catch {
      toast.error("Unexpected error occurred.");
    } finally {
      setConfirming(false);
    }
  };

  // ── Print ────────────────────────────────────────────────
  const handlePrint = () => {
    const id = invoiceIdRef.current || "N/A";
    const printWindow = window.open("", "_blank", "width=400,height=600");
    printWindow.document.write(`
      <html>
      <head>
        <style>
          body { font-family: Calibri, sans-serif; font-size: 12px; margin: 0; padding: 0; }
          .receipt-container { width: 300px; margin: 0 auto; padding: 5px; }
          table { width: 100%; border-collapse: collapse; }
          th, td { text-align: left; padding: 4px; }
          th { border-bottom: 1px solid #000; }
          .text-right { text-align: right; }
        </style>
      </head>
      <body onload="window.print(); window.close();">
        <div class="receipt-container">
          <div style="text-align:center;">
            <h2 style="margin:0;">Said Ahmed Memorial Medical Centre</h2>
          </div>
          <h3>Invoice # ${id}</h3>
          <p><strong>Patient:</strong> ${patientName || "N/A"}</p>
          <p><strong>Doctor:</strong> ${doctorName || "N/A"}</p>
          <p><strong>Date:</strong> ${formatDate(saleDate)}</p>
          <hr/>
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Qty</th>
                <th class="text-right">Unit Price</th>
                <th class="text-right">Total</th>
              </tr>
            </thead>
            <tbody>
              ${salesRows
                .map(
                  (row, index) => `
                <tr>
                  <td>${servicesName[index] || "N/A"}</td>
                  <td>${row.quantity || "0"}</td>
                  <td class="text-right">${formatCurrency(row.unit_price || 0)}</td>
                  <td class="text-right">${formatCurrency(
                    (row.quantity || 0) * (row.unit_price || 0)
                  )}</td>
                </tr>
              `
                )
                .join("")}
            </tbody>
          </table>
          <hr/>
          <div style="text-align:right;">
            <h2>Total: ${formatCurrency(calculateTotal())}</h2>
            <p>Thank you for your purchase!</p>
          </div>
        </div>
      </body>
      </html>
    `);
    printWindow.document.close();
  };

  // ── Info cards config ────────────────────────────────────
  const infoCards = [
    {
      label: "Patient",
      value: patientName || "N/A",
      icon: (
        <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8">
          <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
      ),
    },
    {
      label: "Doctor",
      value: doctorName || "N/A",
      icon: (
        <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8">
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      ),
    },
    {
      label: "Sale Date",
      value: formatDate(saleDate),
      icon: (
        <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8">
          <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      ),
    },
  ];

  // ── Render ───────────────────────────────────────────────
  return (
    <>
      {/* Overlay */}
      <div
        className="fixed inset-0 z-50 flex items-center justify-center"
        style={{ background: "rgba(10,37,64,0.45)", backdropFilter: "blur(3px)" }}
        onClick={(e) => e.target === e.currentTarget && handleClose()}
      >
        <div
          className="bg-white rounded-2xl shadow-2xl w-full flex flex-col"
          style={{ maxWidth: 620, maxHeight: "88vh", animation: "slideUp 0.25s ease" }}
        >
          {/* ── Modal Header ── */}
          <div className="bg-gray-800 px-6 py-4 rounded-t-2xl flex items-center justify-between flex-shrink-0">
            <div>
              <h2 className="text-white text-[17px] font-[500] tracking-tight m-0">
                Medicine Invoice
              </h2>
              <p className="text-gray-400 text-[12px] mt-0.5 mb-0">
                Review details before confirming the sale
              </p>
            </div>
            <button
              onClick={handleClose}
              className="w-8 h-8 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition-colors"
            >
              <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* ── Scrollable Body ── */}
          <div className="overflow-y-auto flex-1 px-6 py-5">

            {/* Info cards */}
            <div className="grid grid-cols-3 gap-3 mb-5">
              {infoCards.map(({ label, value, icon }) => (
                <div
                  key={label}
                  className="bg-gray-50 border border-gray-100 rounded-xl px-4 py-3"
                >
                  <div className="flex items-center gap-2 text-gray-400 mb-1">
                    {icon}
                    <span className="text-[11px] uppercase tracking-wide font-[600]">
                      {label}
                    </span>
                  </div>
                  <p className="text-[13px] font-[500] text-gray-800 m-0">{value}</p>
                </div>
              ))}
            </div>

            {/* Items table */}
            <div className="border border-gray-100 rounded-xl overflow-hidden mb-5">
              <table className="w-full">
                <thead>
                  <tr className="bg-gray-800 text-[11px] uppercase text-white">
                    <th className="py-2.5 px-4 text-left font-[600] tracking-wide">Item</th>
                    <th className="py-2.5 px-4 text-center font-[600] tracking-wide">Qty</th>
                    <th className="py-2.5 px-4 text-right font-[600] tracking-wide">Unit Price</th>
                    <th className="py-2.5 px-4 text-right font-[600] tracking-wide">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {salesRows.map((row, index) => {
                    const lineTotal =
                      (Number(row.quantity) || 0) * (Number(row.unit_price) || 0);
                    return (
                      <tr
                        key={index}
                        className="border-t border-gray-100 hover:bg-gray-50 text-[13px] transition-colors"
                      >
                        <td className="py-3 px-4 font-[500] text-gray-800">
                          {servicesName[index] || "N/A"}
                        </td>
                        <td className="py-3 px-4 text-center text-gray-600">
                          {row.quantity}
                        </td>
                        <td className="py-3 px-4 text-right text-gray-600">
                          {formatCurrency(row.unit_price)}
                        </td>
                        <td className="py-3 px-4 text-right font-[500] text-gray-800">
                          {formatCurrency(lineTotal)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {/* Grand Total */}
            <div className="flex justify-end">
              <div className="bg-gray-800 text-white rounded-xl px-6 py-3 flex items-center gap-4">
                <span className="text-[12px] text-white uppercase tracking-wide">
                  Grand Total
                </span>
                <span className="text-[20px] font-[600]">
                  {formatCurrency(calculateTotal())}
                </span>
              </div>
            </div>
          </div>

          {/* ── Footer Actions ── */}
          <div className="border-t border-gray-100 px-6 py-4 flex items-center justify-between flex-shrink-0 rounded-b-2xl bg-white">

            <button
              onClick={handleClose}
              className="text-[13px] text-gray-400 hover:text-gray-600 transition-colors font-[500]"
            >
              ← Cancel
            </button>

            <div className="flex items-center gap-3">
              {/* Print Receipt */}
              <button
                onClick={handlePrint}
                disabled={!saleConfirmed}
                className="flex items-center gap-2 border border-gray-200 text-gray-700 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed text-[13px] font-[500] px-4 py-2 rounded-lg transition-colors"
              >
                <svg width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
                </svg>
                Print Receipt
              </button>

              {/* Confirm Sale */}
              <button
                onClick={handleSubmitSales}
                disabled={confirming}
                className="flex items-center gap-2 bg-gray-800 hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed text-white text-[13px] font-[500] px-5 py-2 rounded-lg transition-colors"
              >
                {confirming ? (
                  <>
                    <span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                    Confirming…
                  </>
                ) : (
                  <>Confirm Sale →</>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </>
  );
};

export default MedicineInvoiceModal;